import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import SwitchWithInfo from '@/components/SwitchWithInfo';
import { SwitchWithInfoProps } from '@/components/SwitchWithInfo/types';
import { UserGroupSyncAssignmentConfigsInput } from '@/types/schema';

import StopAutoAssign from './StopAutoAssign';

interface SettingsProps {
  className?: string;
  userGroupSyncConfigs: UserGroupSyncAssignmentConfigsInput;
  disabled?: boolean;
  switchPlacement?: SwitchWithInfoProps['switchPlacement'];
  onChange: (nextValue: UserGroupSyncAssignmentConfigsInput) => void;
}

function Settings(props: SettingsProps) {
  const { userGroupSyncConfigs, onChange, disabled, switchPlacement, className } = props;
  const { t } = useTranslation();
  const _onChange = useCallback(
    (value: boolean) => onChange({ ...userGroupSyncConfigs, autoAssignGroupUsers: value }),
    [userGroupSyncConfigs, onChange],
  );

  const onStopAutoSelectSelect = useCallback(
    (value?: string) => onChange({ ...userGroupSyncConfigs, deactivateFrom: value }),
    [onChange, userGroupSyncConfigs],
  );

  return (
    <>
      <Stack className={className} direction="col">
        <SwitchWithInfo
          checked={userGroupSyncConfigs.autoAssignGroupUsers}
          description={t('AssignmentCreator:AutoAssignDescription')}
          disabled={disabled}
          label={t('AssignmentCreator:AutoAssignTitle')}
          switchPlacement={switchPlacement}
          onChange={_onChange}
        />
      </Stack>
      {userGroupSyncConfigs.autoAssignGroupUsers ? (
        <StopAutoAssign
          deactivateFrom={userGroupSyncConfigs.deactivateFrom}
          disabled={disabled}
          onStopAutoSelectSelect={onStopAutoSelectSelect}
        />
      ) : null}
    </>
  );
}

export default React.memo(Settings);
